/** کلید کسب‌وکار برای dedupe — یک فعالیت پیگیری حتی با چند notification id */
export const getReminderBusinessKey = (item) => {
  if (!item) return '';

  const nav = item.navigation || {};
  const followUpId = item.follow_up_id ?? nav.follow_up_id;
  const entityId = item.entity_id ?? nav.entity_id;
  const entityType = item.entity_type ?? nav.entity_type ?? '';

  if (followUpId != null && followUpId !== '' && entityId != null && entityId !== '') {
    return `followup:${entityType}:${entityId}:${followUpId}`;
  }

  if (item.id != null && item.id !== '') return `id:${item.id}`;

  const date = item.next_follow_up_date || item.follow_up_date || '';
  const remark = item.remark || '';
  return `fallback:${entityType}:${entityId}:${date}:${remark}`;
};

/** کلید ردیف UI — ترجیحاً همان کلید کسب‌وکار */
export const getReminderKey = (item) => getReminderBusinessKey(item);

/** نرمال‌سازی پاسخ API به آرایه */
export const normalizeReminderList = (res) => {
  const raw =
    res?.data?.notifications ??
    res?.notifications ??
    res?.data ??
    res;

  if (Array.isArray(raw)) return raw;
  if (raw && typeof raw === 'object') {
    if (Array.isArray(raw.notifications)) return raw.notifications;
    if (raw.id != null || raw.follow_up_id != null || raw.entity_id != null) return [raw];
  }
  return [];
};

/** حذف تکراری‌ها بر اساس کلید کسب‌وکار (follow_up + entity) */
export const dedupeReminders = (list) => {
  const seen = new Set();
  return (list || []).filter((item) => {
    const key = getReminderBusinessKey(item);
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
